import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    delay: { type: Number, default: 250 },
    debounce: { type: Boolean, default: false },
  }

  disconnect() {
    clearTimeout(this.timeout)
  }

  submit() {
    if (this.debounceValue) {
      clearTimeout(this.timeout)
      this.timeout = setTimeout(() => {
        this.element.requestSubmit()
      }, this.delayValue)
    } else {
      this.element.requestSubmit()
    }
  }

  clear() {
    const field = this.element.querySelector("input[type=search]")
    const hadValue = field.value !== ""
    field.value = ""
    field.blur()
    if (hadValue) this.submit()
  }
}
